import { Theme } from "@mui/material";

export const getColors = (
  color: string | undefined,
  theme: Theme
): string[] => {
  switch (color) {
    case "pink":
      return [theme.palette.graph.pink, theme.palette.graph.purple];
    case "purple":
      return [theme.palette.graph.purple, theme.palette.graph.pink];
    case "blue":
      return [theme.palette.graph.blue, theme.palette.graph.teal];
    case "teal":
      return [theme.palette.graph.teal, theme.palette.graph.blue];
    case "green":
      return [theme.palette.graph.green, theme.palette.graph.mustard];
    case "mustard":
      return [theme.palette.graph.mustard, theme.palette.graph.green];
    default:
      return ["#FFF", "000"];
  }
};
